import ClaimsCardIconBackground from '../../images/newInsurerPage/claimscardiconBackground.svg';
import ClaimsCardIcon from '../../images/newInsurerPage/claimsCardIcon.svg';
import { ReactComponent as Arrow } from '../../images/newInsurerPage/blueArrow.svg';
import GmcBackground from '../../images/newInsurerPage/GmcBg.svg';
import OnlineBg from '../../images/newInsurerPage/OnlineBackground.svg';
import OfflineBg from '../../images/newInsurerPage/OfflineBackground.svg';
import LabBg from '../../images/newInsurerPage/LabBackground.svg';
import MedicineBg from '../../images/newInsurerPage/MedicineBackground.svg';
import VaccineBg from '../../images/newInsurerPage/VaccinationBackground.svg';
import VisionBg from '../../images/newInsurerPage/VisionBackground.svg';
import ReimbursementBg from '../../images/newInsurerPage/ReimbursementBackground.svg';
import DentalBg from '../../images/newInsurerPage/DentalBackground.svg';
import ConditionMgmtBg from '../../images/newInsurerPage/Condition-Management-Bg.svg';
import HomeElderCareBg from '../../images/newInsurerPage/Home-Care-Elder-Care-Bg.svg';
import MaternityCareBg from '../../images/newInsurerPage/Maternity-Care-bg.svg';
import CancerCareBg from '../../images/newInsurerPage/Cancer-Care-Bg.svg';
import AyurvedaBg from '../../images/newInsurerPage/Ayurveda-Bg.svg';
import MentalHealthBg from '../../images/newInsurerPage/Mental-health-bg.svg';
import GymFitnessBg from '../../images/newInsurerPage/Gym-fitness-bg.svg';
import MedicalEquipmentBg from '../../images/newInsurerPage/Medical-equipment-bg.svg';
import AHCBackground from '../../images/newInsurerPage/AHCBackground.svg';
import PhysiotherapyBackground from '../../images/newInsurerPage/PhysioThereapyBackgroung.svg';

import OnlineIcon from '../../images/newInsurerPage/OnlineConsultationIcon.svg';
import OfflineIcon from '../../images/newInsurerPage/OfflineCOnsultationIcon.svg';
import LabsIcon from '../../images/newInsurerPage/LabDiagnosticsIcon.svg';
// import AHCIcon from '../../images/newInsurerPage/AnnualHealthCheckupIcon.svg';
import MedicineOrderIcon from '../../images/newInsurerPage/MedicineOrderIcon.svg';
import ReimbursementIcon from '../../images/newInsurerPage/ReimbarsmentIcon.svg';
import dentalIcon from '../../images/newInsurerPage/dentalIcon.svg';
import VaccinationIcon from '../../images/newInsurerPage/vaccinationIcon.svg';
import VisionIcon from '../../images/newInsurerPage/visionIcon.svg';
import ConditionMgmtIcon from '../../images/newInsurerPage/condition-mgmt-icon.svg';
import HomeElderCareIcon from '../../images/newInsurerPage/home-elder-care-icon.svg';
import MaternityCareIcon from '../../images/newInsurerPage/maternity-care-icon.svg';
import CancerCareIcon from '../../images/newInsurerPage/cancer-care-icon.svg';
import AyurvedaIcon from '../../images/newInsurerPage/ayurveda-care-icon.svg';
import MentalHealthIcon from '../../images/newInsurerPage/mental-health-icon.svg';
import GymFitnessIcon from '../../images/newInsurerPage/gym-and-fitness-icon.svg';
import MedicalEquipmentIcon from '../../images/newInsurerPage/medical-equipment-icon.svg';
import AHCIcon from '../../images/newInsurerPage/ReimbursementIcon.svg';
import PhysiotherapyIcon from '../../images/newInsurerPage/PhysiotherapyIcon.svg';

const DiscountTag = ({ value, unit }) => (
  <div
    className="absolute top-0 right-0 bg-primary px-12px text-body-s font-bolder rounded-bl-xl flex items-center justify-center"
    style={{
      width: 'fit-content',
      background: 'linear-gradient(146.4deg, var(--primary-button, #714fff) 21.38%, #210F6D 87.6%)',
      height: '22px',
    }}
  >
    <span
      style={{
        background:
          'linear-gradient(158.99deg, #FFD26F 11.12%, #FFC851 29.27%, #FFDA89 48.29%, #E09A01 72.32%, #FFC340 86.02%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        color: 'transparent',
      }}
    >
      Flat {value} {unit} Off
    </span>
  </div>
);

const OBJECT_MAPPING = {
  dental: {
    icon: dentalIcon,
    background: DentalBg,
    textColor: '#2D60B3',
  },
  'my-claims': {
    icon: ClaimsCardIcon,
    background: ClaimsCardIconBackground,
    textColor: 'var(--primary-button, #714fff)',
  },
  'gmc-policy': {
    icon: ClaimsCardIcon,
    background: GmcBackground,
    textColor: '#3880B4',
  },
  labs: {
    icon: LabsIcon,
    background: LabBg,
    textColor: '#118076',
  },
  'offline-consult': {
    icon: OfflineIcon,
    background: OfflineBg,
    textColor: '#C27C00',
  },
  'online-consult': {
    icon: OnlineIcon,
    background: OnlineBg,
    textColor: '#20768F',
  },
  vaccination: {
    icon: VaccinationIcon,
    background: VaccineBg,
    textColor: '#B53657',
  },
  ahc: {
    icon: AHCIcon,
    background: AHCBackground,
    textColor: '#168F86',
  },
  pharmacy: {
    icon: MedicineOrderIcon,
    background: MedicineBg,
    textColor: '#4B30A8',
  },
  reimbursement: {
    icon: ReimbursementIcon,
    background: ReimbursementBg,
    textColor: '#FA856B',
  },
  vision: {
    icon: VisionIcon,
    background: VisionBg,
    textColor: '#47279C',
  },
  'condition-management': {
    icon: ConditionMgmtIcon,
    background: ConditionMgmtBg,
    textColor: '#2874E5',
  },
  'home-care-and-elder-care': {
    icon: HomeElderCareIcon,
    background: HomeElderCareBg,
    textColor: '#93240D',
  },
  'maternity-care': {
    icon: MaternityCareIcon,
    background: MaternityCareBg,
    textColor: '#297166',
  },
  'cancer-care': {
    icon: CancerCareIcon,
    background: CancerCareBg,
    textColor: '#7651DA',
  },
  'ayurveda-and-rejuvenation': {
    icon: AyurvedaIcon,
    background: AyurvedaBg,
    textColor: '#684BDF',
  },
  'mental-health-therapy': {
    icon: MentalHealthIcon,
    background: MentalHealthBg,
    textColor: '#93240D',
  },
  'gym-and-fitness': {
    icon: GymFitnessIcon,
    background: GymFitnessBg,
    textColor: '#C27D20',
  },
  'medical-equipment': {
    icon: MedicalEquipmentIcon,
    background: MedicalEquipmentBg,
    textColor: '#297166',
  },
  physiotherapy: {
    icon: PhysiotherapyIcon,
    background: PhysiotherapyBackground,
    textColor: '#B53657',
  },
};

const NewHealthBenefitsCard = (props) => {
  const {
    themeKey,
    title,
    benefitsWithIcons,
    benefitsWithoutIcons,
    redirectTo,
    discountLabel,
  } = props?.data;
  const themeColor = OBJECT_MAPPING[themeKey]?.textColor;
  return (
    <div
      onClick={props.onTap}
      className="relative flex flex-col mb-80px rounded-12 px-16px py-16px overflow-hidden "
      style={{
        border: `1px solid ${themeColor}80`,
      }}
    >
      <div className="flex w-full">
        <img
          src={OBJECT_MAPPING[themeKey]?.background}
          alt=""
          className="absolute top-0 left-0 w-full h-full rounded-12 overflow-hidden object-cover"
        />
        {discountLabel ? (
          <DiscountTag
            value={String(discountLabel.value)}
            unit={String(discountLabel.unit)}
          />
        ) : null}
        <div className="z-10">
          <img
            src={OBJECT_MAPPING[themeKey]?.icon}
            alt="icon"
            style={{
              width: '42px',
              height: '42px',
            }}
            className="mr-4"
          />
        </div>
        <div className=" z-10 w-full">
          <div className="w-full flex items-center justify-between">
            <div className="flex flex-col">
              <div
                style={{
                  color: themeColor,
                }}
                className="text-body-m font-bold mb-1"
              >
                {title}
              </div>
              {benefitsWithoutIcons?.map((item, index) => (
                <div className="text-chip font-medium leading-4 text-txtlight">
                  <span>{item.benefitText}</span>
                </div>
              ))}
            </div>
            {redirectTo && (
              <Arrow fill={themeColor} alt="" className="h-16px mr-12px" />
            )}
          </div>
        </div>
      </div>
      {benefitsWithIcons.length > 0 && (
        <div
          className="z-10 rounded-12 my-2"
          style={{
            border: `1px solid ${themeColor}80`,
          }}
        >
          <div className="flex flex-col rounded-20 px-4 py-2 ">
            {benefitsWithIcons?.map((item, index) => {
              return (
                <div
                  borderBottom={!(index === benefitsWithIcons.length - 1)}
                  className="flex text-body-s font-medium my-1 pb-2"
                  style={
                    index !== benefitsWithIcons.length - 1
                      ? {
                          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                        }
                      : {}
                  }
                >
                  <div className="mr-2">
                    <div
                      style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: themeColor,
                        WebkitMaskImage: `url(${item.iconUrl})`,
                        WebkitMaskRepeat: 'no-repeat',
                        WebkitMaskPosition: 'center',
                        WebkitMaskSize: 'contain',
                        maskImage: `url(${item.iconUrl})`,
                        maskRepeat: 'no-repeat',
                        maskPosition: 'center',
                        maskSize: 'contain',
                      }}
                    />
                  </div>
                  <div className="flex flex-col ">
                    <div className="text-body-s font-bold text-txtsecondary">
                      {item.title}
                    </div>
                    <div className="text-chip font-medium text-txtsecondary flex gap-1 leading-4 ">
                      <span>&bull;</span>
                      {item.benefitText}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default NewHealthBenefitsCard;
